import { DialogContentComponentBase, DialogContentViewModel, DialogInsService, DialogState, ToastService } from '@skylab-angular-shared/ui';
import { L10nBase } from '@skylab-shared/core';
import { ToastDelay } from '@skylab-shared/ui';
import { AxiosResponse } from 'axios';

export interface DocumentDownloadOverwrittenParams {
    compress: boolean;
    duplicate: boolean;
    dateOfDuplicate?: Date;
    ecoMode: boolean;
    password?: string;
}

export interface DocumentDownloadDialogViewModelBase extends DialogContentViewModel {
    isReady: boolean;
    overwrittenParams: DocumentDownloadOverwrittenParams;
}

export abstract class DocumentDownloadDialogComponentBase<TDocumentDownloadViewModel extends DocumentDownloadDialogViewModelBase, TDownloadDocumentData = unknown>
    extends DialogContentComponentBase<TDocumentDownloadViewModel, TDownloadDocumentData> {
    public constructor(
        dialogService: DialogInsService,
        protected readonly toastService: ToastService,
        protected readonly l10n: L10nBase
    ) {
        super(dialogService);
    }

    protected override getInitialState(): TDocumentDownloadViewModel {
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        return <TDocumentDownloadViewModel>{
            isReady: false,
            overwrittenParams: {
                duplicate: false,
                dateOfDuplicate: now,
                compress: false,
                password: '',
                ecoMode: false
            },
        };
    }

    public isDownloading!: boolean;
    public async downloadDocumentAsync(): Promise<void> {
        try {
            this.isDownloading = true;
            const params = {...this.viewModel.overwrittenParams};
            if (!params.duplicate)
                delete params.dateOfDuplicate;
            if (!params.compress)
                delete params.password;

            await this.onDocumentDownloadAsync(params);
        } catch (err) {
            this.onDownloadError(err as any);
            this.onAction({state: DialogState.Cancel});
        } finally {
            this.isDownloading = false;
        }
    }

    protected abstract onDocumentDownloadAsync(params: DocumentDownloadOverwrittenParams): Promise<void>;

    protected override isReady(): void {
        this.viewModel.isReady = true;
    }

    protected onDownloadError(_: AxiosResponse): void {
        this.toastService.showAsync({
            type: 'error',
            text: this.l10n._T('scenes.shared.dialog.document.download.errors.message'),
            duration: ToastDelay.Regular,
        });
    }
}
